module.exports = __webpack_public_path__ + "img/songtao.9df3bf06.jpg";